import { NavigationConfigurationModel } from '.';
import { formatMessage } from 'src/api';
import MESSAGES from './../../../../app/Partials/Navigation/Navigation.messages';

export const navigationConfigurationData = (id: string): NavigationConfigurationModel => ({
  selectedTrough: {
    active: false,
    disabled: false,
    icon: 'trough',
    name: formatMessage({...MESSAGES.navigationTroughName}),
    title: formatMessage({...MESSAGES.navigationTroughTitle}),
    to: `/configuration/${id}/trough`,
  },
  washBasinDimension: {
    active: false,
    disabled: true,
    icon: 'washbasin-dimensions',
    name: formatMessage({...MESSAGES.navigationBasinName}),
    title: formatMessage({...MESSAGES.navigationBasinTitle}),
    to: `/configuration/${id}/basin-dimensions`,
  },
  apronBackSplash: {
    active: false,
    disabled: true,
    icon: 'apron-backsplash',
    name: formatMessage({...MESSAGES.navigationApronName}),
    title: formatMessage({...MESSAGES.navigationApronTitle}),
    to: `/configuration/${id}/apron-backsplash`,
  },
  builtInParts: {
    active: false,
    disabled: true,
    icon: 'recesses-built-in-parts',
    name: formatMessage({...MESSAGES.navigationRecessesName}),
    title: formatMessage({...MESSAGES.navigationRecessesTitle}),
    to: `/configuration/${id}/recesses`,
  },
  surface: {
    active: false,
    disabled: true,
    icon: 'paint-palette',
    name: formatMessage({...MESSAGES.navigationColourName}),
    title: formatMessage({...MESSAGES.navigationColourTitle}),
    to: `/configuration/${id}/surface`,
  },
  assemblyAccessories: {
    active: false,
    disabled: true,
    icon: 'wrench',
    name: formatMessage({...MESSAGES.navigationAssemblyName}),
    title: formatMessage({...MESSAGES.navigationAssemblyTitle}),
    to: `/configuration/${id}/assemblies`,
  },
  drainAccessories: {
    active: false,
    disabled: true,
    icon: 'drain-accessories',
    name: formatMessage({...MESSAGES.navigationDrainName}),
    title: formatMessage({...MESSAGES.navigationDrainTitle}),
    to: `/configuration/${id}/drain`,
  }
});
